<template>
  <base-view
      @click:config="config"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

      <create-edit-mensagem-dialog :item="item" 
                                :responsaveisSelecionados="linhasSelecionadas"
                                :search-values="searchValues"
                                v-model="editDialogOpened"
                                @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <mensagens-data-table ref="dataTable" 
                            :selection.sync="selection"
                            :search-values="searchValues"/>
    </div>
  </base-view>

</template>

<script>
import MensagensDataTable from "../../components/shared/datatables/MensagensDataTable";
import BaseView from "../BaseView";
import CreateEditMensagemDialog from "../../components/shared/dialogs/CreateEditMensagemDialog";
import {ItemDeDominio} from "../../api/itemsDominio";
import {mapActions, mapGetters} from "vuex";
//Comprador
import {findAll as findAllComprador} from '../../api/comprador';
import {findAll as findAllAtividadeEconomica} from "../../api/atividadeEconomica";
//Fornecedor
import {findAll as findAllFornecedor} from '../../api/fornecedor';
import {findAll as findAllSetor} from "../../api/setor";
import {findAll as findAllPorte} from "../../api/porte";
import {findAll as findAllRamoAtuacao} from "../../api/ramoAtuacao";
import {findAll as findAllOferta} from "../../api/oferta";

export default {
  name: "index",
  props: {
    
  },
  components: {CreateEditMensagemDialog, BaseView, MensagensDataTable},
  data() {
    return {
      selection: [],
      item: null,
      permiteCadastrar: false,
      editDialogOpened: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'Estado',
          column: 'estado',
          type: 'selectMultiple',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.COMBO_ESTADO
          })
        },
        {
          group: 'Fornecedores',
          columns: [        
            {
              name: 'Fornecedor',
              column: 'idFornecedor',
              type: 'autocomplete',
              optionsFactory: (search) => findAllFornecedor(1, {
                nome: search
              })
                  .then(r => {
                    return r.elements.map(e => ({
                      key: e.id,
                      valor: e.nomeCompletoSemCnpj
                    }))
                  })
            },
            {
              name: 'Setor',
              column: 'idSetor',
              type: 'autocomplete',
              optionsFactory: (search) => findAllSetor(1,{
                descricao: search
              })
                  .then(r => {
                    return r.elements.map(e => ({
                      key: e.id,
                      valor: e.descricao
                    }))
                  })
            },
            {
              name: 'Porte',
              column: 'idPorte',
              type: 'autocomplete',
              optionsFactory: (search) => findAllPorte(1,{
                descricao: search
              })
                  .then(r => {
                    return r.elements.map(e => ({
                      key: e.id,
                      valor: e.descricao
                    }))
                  })
            }, 
            {
              name: 'Ramo de Atuação',
              column: 'idRamoAtuacao',
              type: 'autocomplete',
              optionsFactory: (search) => findAllRamoAtuacao(1,{
                descricao: search
              })
                  .then(r => {
                    return r.elements.map(e => ({
                      key: e.id,
                      valor: e.descricao
                    }))
                  })
            },
            {
              name: 'Oferta',
              column: 'idOferta',
              type: 'autocomplete',
              optionsFactory: (search) => findAllOferta(1,{
                descricao: search
              })
                  .then(r => {
                    return r.elements.map(e => ({
                      key: e.id,
                      valor: e.descricao
                    }))
                  })
            },
            {
              name: 'Status',
              column: 'flgStatusFornecedor',
              type: 'select',
              optionsFactory: () => this.fetch({
                itemDominio: ItemDeDominio.STATUS_MODERACAO
              })
            },
          ]
        },
        {
          group: 'Compradores',
          columns: [           
            {
              name: 'Comprador',
              column: 'idComprador',
              type: 'autocomplete',
              optionsFactory: (search) => findAllComprador(1, {
                nome: search
              })
                  .then(r => {
                    return r.elements.map(e => ({
                      key: e.id,
                      valor: e.nomeCompletoSemCnpj
                    }))
                  })
            },
            {
              name: 'Atividade Econômica',
              column: 'idAtividadeEconomica',
              type: 'autocomplete',
              optionsFactory: (search) => findAllAtividadeEconomica(1,{
                nome: search
              })
                  .then(r => {
                    return r.elements.map(e => ({
                      key: e.id,
                      valor: e.descricao
                    }))
                  })
            },
            {
              name: 'Status',
              column: 'flgStatusComprador',
              type: 'select',
              optionsFactory: () => this.fetch({
                itemDominio: ItemDeDominio.STATUS_MODERACAO
              })
            },
          ]
        },        
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
    linhasSelecionadas() {
      return this.selection.map(s => s.id);
    }
  },
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    config() {
      this.item = {};
      this.editDialogOpened = true;
    },
	  async getPermissoes(){
      this.getPermissaoPorItemPerfil("Mensagem.cadastroPorGrupo",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });      
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>